/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useEffect, useState } from "react";
import { DocumentStyleIcon } from "./field/icon";
import { DocumentStyleSimple } from "./field/simple";
import { DocumentStyleSimpleNoSize } from "./field/simple-no-size";
import { DocumentStyleBullet } from "./field/bullet";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { readTarget, DOCUMENT_FIELD_FORMATS } from "./helpers";
import { Logger } from "cms/utils/log/logger";

/*
     FIXME: this exists separate from Document used by Component
        as the field has formats for each item, while component
        has one format for the list
 */

const FieldDocument = (props) => {
    
    const {
        document: guid,
        style,
        format,
        options,
        clickEnabled = true
    } = props || {};
    const isIcon = format === DOCUMENT_FIELD_FORMATS.ICON;
    const isBullet = format === DOCUMENT_FIELD_FORMATS.BULLET;
    const isSimple = format === DOCUMENT_FIELD_FORMATS.SIMPLE;
    const isSimpleNoSize = format === DOCUMENT_FIELD_FORMATS.SIMPLE_NO_SIZE;
    // const isOther = (!isIcon && !isSimple && !isBullet && !isSimpleNoSize) === false
    const isOther = !isIcon && !isSimple && !isBullet && !isSimpleNoSize;
    
    const { token } = useAuth();
    const [documentGuid, setDocumentGuid] = useState();
    const [document, setDocument] = useState();
    
    const onClickHandler = async (event, document) => {
        if (clickEnabled) {
            const targetData = readTarget(options);
            const { handler } = targetData || {};
            if (handler && typeof handler === "function") {
                event.preventDefault();
                handler(event, document.url);
            }
        }
    };

    useEffect(() => {
        const fetchDocument = async () => {
            if (guid && documentGuid !== guid) {
                let current_doc = await SimpliCityAdminSDK.document.findOne(token, guid);
                if (current_doc && current_doc.guid) {
                    setDocument(current_doc);
                    setDocumentGuid(current_doc.guid);
                } else {
                    Logger.debug("Could not load document...", guid);
                }
            } else {
                setDocument(undefined);
            }
        };
        fetchDocument();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);
    
    return (
        <Fragment>
            <>
                {isIcon && document &&
                    <DocumentStyleIcon
                        document={document}
                        style={style}
                        options={options}
                        onClickHandler={onClickHandler}
                    />
                }
                {isBullet && document &&
                    <DocumentStyleBullet
                        document={document}
                        style={style}
                        options={options}
                        onClickHandler={onClickHandler}
                    />
                }
                {isSimple && document &&
                    <DocumentStyleSimple
                        document={document}
                        style={style}
                        options={options}
                        onClickHandler={onClickHandler}
                    />
                }
                {isSimpleNoSize && document &&
                    <DocumentStyleSimpleNoSize
                        document={document}
                        style={style}
                        options={options}
                        onClickHandler={onClickHandler}
                    />
                }
                {isOther && document &&
                    <DocumentStyleIcon
                        document={document}
                        style={style}
                        options={options}
                        onClickHandler={onClickHandler}
                    />
                }
                
            </>
        </Fragment>
    );
};
export { FieldDocument };

/*
A sample of the schema we add for documents
const schema = {
  "label":"Document",
  "description": "A field containing the Bylaw Document upload",
  "defaultValue": null,
  "defaultStyle": "field.style.body",
  "defaultFormat": "field.format.card-icon",
  "noOverride": false,
  "hidden": false,
  "placeholder": "Please upload or select a document",
  "styleOptions": [
    { "name": "Body", "value": "field.style.body" },
    { "name": "Heading 1", "value": "field.style.h1" },
    { "name": "Heading 2", "value": "field.style.h2" },
    { "name": "Heading 3", "value": "field.style.h3" },
    { "name": "Heading 4", "value": "field.style.h4" }
  ],
  "formatOptions": [
    {"name": "Card", "value": "field.format.document-card"},
    {"name": "Card with icon", "value": "field.format.document-card-icon"},
    {"name": "Title and size", "value": "field.format.document-title-size"},
    {"name": "Title and size with icon", "value": "field.format.document-title-size-icon"},
    {"name": "Simple", "value": "field.format.document-simple"},
    {"name": "Simple with icon", "value": "field.format.document-simple-icon"}
  ],
  "options": {
    targets: [
      "label": "New tab", "value": "tab"
      "label": "New window", "value": "window"
      "label": "Current", "value": "self"
    ]
  }
}
*/
